import { useMutation } from '@tanstack/react-query';
import type { PlaceImportFromGmapsResponse } from '@upme/contracts';
import { api } from '../../../app/api-client';

export function usePlaceImportFromGmaps() {
  return useMutation({
    mutationFn: (url: string): Promise<PlaceImportFromGmapsResponse> =>
      api.post('admin/places/import-from-gmaps', { json: { url } }).json<PlaceImportFromGmapsResponse>(),
  });
}
